import type { PaidRung } from '../api/client'

// The rung she left for Stripe Checkout to pay for, so the confirming page
// she comes back to knows what it is waiting for. Session storage: it is
// only needed for the round trip, and a blocked store means waiting for
// card payments, which Pro also turns on.
const KEY = 'harmovi.billing.pending'

export function rememberPending(rung: PaidRung): void {
  try {
    sessionStorage.setItem(KEY, rung)
  } catch {
    // Private mode: the confirming page waits for card payments instead.
  }
}

export function pendingRung(): PaidRung | null {
  try {
    const v = sessionStorage.getItem(KEY)
    return v === 'pro' || v === 'card_payments' ? v : null
  } catch {
    return null
  }
}

export function forgetPending(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // nothing to forget
  }
}
